<template>
	<div class="flex gap-1 md:gap-4 max-md:flex-col items-end md:items-center flex-wrap">
		<span v-if="product.unitAmount" class="text-xs md:text-xl text-body-tertiary md:font-semibold md:font-secondary max-md:bg-light-300 max-md:p-1 max-md:rounded-lg">
			{{ product.unitAmount }} {{ product.unitId }}
		</span>
		<span v-if="product.productInHouse" class="text-body-quaternary text-xs md:text-sm flex md:gap-2 flex-col md:flex-row text-end">
			<span v-if="product.productInHouse.comparisonPrice && product.productInHouse.comparisonSaleUnitSizeText">
				{{ $n(product.productInHouse.comparisonPrice, 'currencyWithPennies') }}/
				{{ removeDecimalComma(product.productInHouse.comparisonSaleUnitSizeText) }}
			</span>
			<span v-if="product.productInHouse.bonusProgramPrice && product.productInHouse.bonusProgramPrice.comparisonPrice && product.productInHouse.bonusProgramPrice.comparisonSaleUnitSizeText" class="max-md:hidden">|</span>
			<span v-if="product.productInHouse.bonusProgramPrice && product.productInHouse.bonusProgramPrice.comparisonPrice && product.productInHouse.bonusProgramPrice.comparisonSaleUnitSizeText" class="flex items-center gap-1">
				<NuxtIcon name="custom/heart" class="text-[1.1875rem]" />
				{{ $n(product.productInHouse.bonusProgramPrice.comparisonPrice, 'currencyWithPennies') }}/
				{{ removeDecimalComma(product.productInHouse.bonusProgramPrice.comparisonSaleUnitSizeText) }}
			</span>
		</span>
	</div>
</template>

<script setup lang="ts">
	import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';
	import {removeDecimalComma} from '~/utils/products';

	type Props = {
		product: ProductDetail;
	};

	defineProps<Props>();
</script>
